import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as componentActions from '../../../project-details/actions/pms';

@Injectable()
export class ProjectMediaSourcesService {

  constructor(private store: Store<any>) { }

  setActive() {
    this.store.dispatch({type: componentActions.PROJECT_DETAILS_PMS_ACTIVATE});
  }

  setInActive() {
    this.store.dispatch({type: componentActions.PROJECT_DETAILS_PMS_DEACTIVATE});
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/project-media-sources/services/project-media-sources.service.ts